export default {
  text: 'Du hast vor weniger als 15 Minuten eine Bestellung aufgegeben! Bitte bestätige, ob du mit dieser neuen Bestellung fortfahren oder deine bestehende Bestellung sehen möchtest.',
  buttons: {
    see_existing_order: 'Zur Laufenden Bestellung',
    proceed_new_order: 'Neue Bestellung Fortsetzen',
  },
};
